const E = ["#79c346", "#ee7206", "#e23e1c", "#941414"], _ = ["#79c346", "#ffb526", "#ee7206", "#e20000", "#941414"], c = [
  "#79c346",
  "#c2c52c",
  "#ffb526",
  "#fd7702",
  "#e20000",
  "#941414"
];
export {
  E as TRAFFIC_VOLUME_GREEN_RED_4,
  _ as TRAFFIC_VOLUME_GREEN_RED_5,
  c as TRAFFIC_VOLUME_GREEN_RED_6
};
//# sourceMappingURL=index.es5568.js.map
